import slick from "../vendor/slick"

let sliders

const VideoSlider = {
  init: function() {
    sliders = document.querySelectorAll('.video-slider')
    if (!sliders) return

    sliders.forEach((slider, index) => this.initSlider(slider, index))

    window.addEventListener('resize', this.updateNavHeight)
  },

  initSlider: function(slider, index) {
    const perView = +slider.dataset.perView
    const sliderId = `video-slider-${index}`
    const wrapper = slider.closest('.video-carousel-videos')

    const nav = wrapper.querySelector('.video-carousel-nav')
    const nextBtn = wrapper.querySelectorAll('.slider-btn.next')
    const prevBtn = wrapper.querySelectorAll('.slider-btn.prev')

    slider.id = sliderId

    if (index == (sliders.length - 1)) {
      wrapper.classList.add('last')
    }

    $('#' + sliderId).slick({
      slidesToShow: perView,
      slidesToScroll: 1,
      initialSlide: 0,
      centerMode: false,
      infinite: false,
      prevArrow: prevBtn,
      nextArrow: nextBtn,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: perView > 2 ? 3 : 2,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    })

    nav.style.height = wrapper.querySelector('.video-cover')?.getBoundingClientRect().height + 'px'
  },

  updateNavHeight: function() {
    if (!sliders) return

    sliders?.forEach(slider => {
      setTimeout(() => {
        const wrapper = slider.closest('.video-carousel-videos')
        const nav = wrapper.querySelector('.video-carousel-nav')
        if (nav) {
          nav.style.height = slider.querySelector('.video-cover').getBoundingClientRect().height + 'px'
          nav.style.transition = 'height 0.3s ease';
        }
      }, 500)
    })
  }
}

export default VideoSlider
